import React from 'react';
import { Box } from '@mui/material';
import { keyframes } from '@emotion/react';

import { usePanelData, usePanelPlatform } from './PanelData';
import logo from '../assets/logo.svg';
import logoBusy from '../assets/logo-busy.svg';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const logoSx = { width: 48, height: 48 } as const;

/**
 * The header's logo: a link to the web app's home, and the spinning bone while
 * the legacy assistant is writing (`busy.assistant`).
 */
const PanelLogo: React.FC = () => {
  const { webappUrl } = usePanelPlatform();
  const { busy } = usePanelData();
  return (
    <a href={`${webappUrl}/home`} target="_blank" rel="noopener noreferrer">
      {busy.assistant ? (
        <Box
          component="img"
          src={logoBusy}
          alt="Loading..."
          sx={{
            ...logoSx,
            animation: `${spin} 2s infinite`,
            animationTimingFunction: 'cubic-bezier(0.42, 0, 0.58, 1)',
          }}
        />
      ) : (
        <Box component="img" src={logo} alt="Logo" sx={logoSx} />
      )}
    </a>
  );
};

export default PanelLogo;
